export function getQuantityLabel(quantity: number, word = 'Note'): string {
  if (quantity === 0) {
    return word + 's';
  } else if (quantity === 1) {
    return '1 ' + word;
  }

  return `${ quantity } ${ word }s`;
}
